import * as React from 'react';
import { cn } from '../../lib/cn';

/**
 * Label — shadcn label idiom, themed onto HofSync brand tokens. A plain <label>
 * (no Radix dependency needed for the bounded form slice); associate it with a
 * control via `htmlFor`. `tw:peer-disabled:*` dims the label when an adjacent
 * `peer`-marked control is disabled (shadcn convention).
 */
export type LabelProps = React.LabelHTMLAttributes<HTMLLabelElement>;

export const Label = React.forwardRef<HTMLLabelElement, LabelProps>(
  ({ className, ...props }, ref) => (
    <label
      ref={ref}
      className={cn(
        'tw:text-sm tw:font-medium tw:leading-none tw:text-foreground',
        'tw:peer-disabled:cursor-not-allowed tw:peer-disabled:opacity-70',
        className
      )}
      {...props}
    />
  )
);
Label.displayName = 'Label';
